import { render, staticRenderFns } from "./OpenDoorSectionIcon.vue?vue&type=template&id=6defa60e"
import script from "./OpenDoorSectionIcon.vue?vue&type=script&lang=js"
export * from "./OpenDoorSectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports